/*
    Displays drop down where user can pick date
    in actual it returns start date and end date.

    there is just options for the user to pick one
*/
import React, { Component } from 'react';

import lodash from 'lodash';
import DatePicker from 'react-datepicker';

import {
   ButtonDropdown,
   DropdownMenu,
   DropdownItem,
   Row,
   Col,
   Input,
} from 'reactstrap';

import { UpwardActions } from 'ui';

const dateFormatOptions = { year: 'numeric', month: 'numeric', day: 'numeric' };
const dateFormat = 'en-US';
const dateSelectionOptions = ['Today', 'Yesterday', 'Last 7 Days', 'Last 30 Days', 'Custom'];

export const dateFormatter = (inDate) => {
   const t = new Date(inDate);
   const formatted = t.toLocaleDateString(dateFormat, dateFormatOptions);
   return formatted;
};

export const getDateRangeDisplay = (fromDate, toDate) => {
   if (!lodash.isDate(fromDate)) {
      fromDate = fromDate.replace(/-/g, '/');
      fromDate = new Date(fromDate);
   }
   if (!lodash.isDate(toDate)) {
      toDate = toDate.replace(/-/g, '/');
      toDate = new Date(toDate);
   }
   const testTodayDate = new Date(); testTodayDate.setHours(0, 0, 0, 0);
   const testYesterdayDate = new Date(); testYesterdayDate.setHours(0, 0, 0, 0);
   testYesterdayDate.setDate(testYesterdayDate.getDate() - 1);
   const testPastWeekDate = new Date(); testPastWeekDate.setHours(0, 0, 0, 0);
   testPastWeekDate.setDate(testPastWeekDate.getDate() - 7);
   const testCurrentMonthDate = new Date(); testCurrentMonthDate.setHours(0, 0, 0, 0);
   testCurrentMonthDate.setDate(1);
   // let testPastMonthStart = new Date(); testPastMonthStart.setHours(0,0,0,0);
   // testPastMonthStart.setDate( 1 );
   // testPastMonthStart.setMonth( testPastMonthStart.getMonth() -1 );
   // let testPastMonthEnd = new Date(); testPastMonthEnd.setHours(0,0,0,0);
   // testPastMonthEnd.setMonth( testPastMonthStart.getMonth() + 1 );
   // testPastMonthEnd.setDate( 0 );
   const testLast30Days = new Date(); testLast30Days.setHours(0, 0, 0, 0);
   testLast30Days.setDate(testLast30Days.getDate() - 30);
   const testLastWeekStart = new Date(); testLastWeekStart.setHours(0, 0, 0, 0);
   const testLastWeekEnd = new Date(); testLastWeekEnd.setHours(0, 0, 0, 0);
   testLastWeekStart.setDate(testLastWeekStart.getDate() - 7);
   // @TODO remove ==
   testLastWeekStart.setDate(testLastWeekStart.getDate() - testLastWeekStart.getDay() + (testLastWeekStart.getDay() == 0 ? -6 : 0));
   testLastWeekEnd.setDate(testLastWeekStart.getDate() + 6);
   if (fromDate.getTime() === toDate.getTime()) {
      if (fromDate.getTime() === new Date(testTodayDate).getTime()) {
         return 'Today';
      } else if (fromDate.getTime() === new Date(testYesterdayDate).getTime()) {
         return 'Yesterday';
      } else {
         return 'Custom';
      }
   } else if (toDate.getTime() === new Date(testTodayDate).getTime() && fromDate.getTime() === new Date(testPastWeekDate).getTime()) {
      return 'Last 7 Days';
   } else if (toDate.getTime() === new Date(testTodayDate).getTime() && fromDate.getTime() === new Date(testCurrentMonthDate).getTime()) {
      return 'Current Month';
      // } else if( toDate.getTime() === new Date( testPastMonthEnd ).getTime() && fromDate.getTime() === new Date( testPastMonthStart ).getTime() ){
      //     return "Past Month";
   } else if (toDate.getTime() === new Date(testTodayDate).getTime() && fromDate.getTime() === new Date(testLast30Days).getTime()) {
      return 'Last 30 Days';
      // } else if ( fromDate.getTime() === new Date( testLastWeekStart ).getTime() && toDate.getTime() === new Date( testLastWeekEnd ).getTime() ){
      //     return "Past Week";
   } else {
      return 'Custom';
   }
};

const DatePickerCustom = ({ value, onClick, onChange }) => (
   <Input value={value} onClick={onClick} onChange={onChange} ></Input>
);

class TimeFilter extends Component {
   constructor(props) {
      super(props);
      this.state = {
         currentSelection: ((props.currentSelection && dateSelectionOptions.findIndex((item) => props.currentSelection.toLowerCase() === item.toLowerCase()) > -1) ? props.currentSelection : 'Today'),
         startDate: new Date(props.fromDate),
         endDate: new Date(props.toDate),
         dropdownOpen: false,
      };
      this.toggle = this.toggle.bind(this);
      this.onDropdownSelection = this.onDropdownSelection.bind(this);
      this.setStartDate = this.setStartDate.bind(this);
      this.setEndDate = this.setEndDate.bind(this);
   }

   componentDidUpdate(prevProps, prevState) {
      if ((this.props.fromDate && new Date(this.props.fromDate).getTime() !== new Date(prevProps.fromDate).getTime())
         || (this.props.toDate && new Date(this.props.toDate).getTime() !== new Date(prevProps.toDate).getTime())
      ) {
         this.setState({
            startDate: new Date(this.props.fromDate),
            endDate: new Date(this.props.toDate),
         }, () => {
            this.updateCurrentSelection();
         });
      }
   }

   updateCurrentSelection() {
      const dateRangeDisplay = getDateRangeDisplay(this.state.startDate, this.state.endDate);
      this.setState({
         currentSelection: dateRangeDisplay,
      });
   }

   toggle() {
      this.setState({
         dropdownOpen: !this.state.dropdownOpen,
      });
   }

   onDropdownSelection(event, item) {
      this.setState({
         currentSelection: item,
      }, () => {
         let start = new Date();
         let end = new Date();
         switch (this.state.currentSelection) {
            case 'Yesterday':
               start.setDate(start.getDate() - 1);
               end.setDate(end.getDate() - 1);
               break;
               // case "Past Week":
               //     let lastWeekDate = new Date();
               //     lastWeekDate.setDate( start.getDate() - 7 );
               //     lastWeekDate.setDate( lastWeekDate.getDate() - lastWeekDate.getDay() + ( lastWeekDate.getDay() === 0 ? -6 : 0 ) );
               //     start = lastWeekDate;
               //     end.setDate( start.getDate() + 6 );
               //     break;
            case 'Last 7 Days':
               start.setDate(start.getDate() - 7);
               break;
               // case "Past Month":
               //     start.setDate( 1 );
               //     start.setMonth( start.getMonth() -1 );
               //     end.setMonth( start.getMonth() + 1 );
               //     end.setDate( 0 );
               //     break;
            case 'Current Month':
               start.setDate(1);
               break;
            case 'Last 30 Days':
               start.setDate(start.getDate() - 30);
               break;
            case 'Custom':
               start = this.state.startDate;
               end = this.state.endDate;
               break;
            case 'Today':
            default:
               break;
         }
         this.setState({
            startDate: start,
            endDate: end,
         }, () => {
            this.onDateSelection();
         });
      });
   }

   onDateSelection() {
      if (this.props.onChange) {
         const obj = {};
         obj.fromDate = dateFormatter(this.state.startDate);
         obj.toDate = dateFormatter(this.state.endDate);
         this.props.onChange(obj);
      }
   }

   setStartDate(date) {
      this.setState({
         startDate: date,
      }, () => {
         this.onDateSelection();
      });
   }

   setEndDate(date) {
      this.setState({
         endDate: date,
      }, () => {
         this.onDateSelection();
      });
   }

   selectionTitleCase(str) {
      return str.replace(/\w\S*/g, (txt) => {
         return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
   }

   render() {
      const { currentSelection } = this.state;
      const onClickHandler = this.onDropdownSelection;
      return (
         <Row>
            <Col xs='4' lg='3' xl='2'>
               <ButtonDropdown className='btn-block' isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                  <UpwardActions>
                     {this.selectionTitleCase(currentSelection)}
                  </UpwardActions>
                  <DropdownMenu style={{ width: '240px' }}>
                     {
                        dateSelectionOptions.map((item, index) => {
                           return (
                              <DropdownItem
                                 onClick={(event) => onClickHandler(event, item)}
                                 active={item == currentSelection}
                                 key={index}
                              >
                                 {item}
                              </DropdownItem>
                           );
                        })
                     }
                  </DropdownMenu>
               </ButtonDropdown>
            </Col>
            <Col xs='3'>
               <DatePicker
                  selected={this.state.startDate}
                  customInput={<DatePickerCustom />}
                  onChange={(date) => this.setStartDate(date)}
                  selectsStart
                  startDate={this.state.startDate}
                  placeholder='Start Date'
                  endDate={this.state.endDate}
               />
            </Col>
            <Col xs='3'>
               <DatePicker
                  selected={this.state.endDate}
                  customInput={<DatePickerCustom />}
                  onChange={(date) => this.setEndDate(date)}
                  selectsEnd
                  minDate={this.state.startDate}
                  placeholder='End Date'
                  startDate={this.state.startDate}
               />
            </Col>
         </Row>
      );
   }
}

TimeFilter.defaultProps = {
   fromDate: new Date(),
   toDate: new Date(),
};

export default TimeFilter;
